import type { Tractor } from '@src/tractor/domain/Tractor';
import { TractorClient } from '@src/tractor/services/TractorClient';
import { useQuery } from '@tanstack/react-query';

export const useTractor = (clientId: string, tractorId: string) => {
  const { data: tractor = null, isLoading } = useQuery<Tractor | null>({
    queryKey: ['tractors.get', clientId, tractorId],
    queryFn: () => TractorClient.get(clientId, tractorId),
    enabled: !!clientId && !!tractorId,
  });
  return {
    tractor,
    isLoading,
  };
};
